
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
components: {
Tabbar,
TabbarItem
},
data() {
return {
bHeight: 0
}
},
computed: {
isActivity() {
return /activity/.test(this.$route.path)
},
isUser() {
return /user/.test(this.$route.path)
},
isCurriculum() {
return /curriculum/.test(this.$route.path)
}
},
mounted() {
this.bHeight = document.querySelector('.tabbar').offsetHeight
window.onresize = () => {
this.bHeight = document.querySelector('.tabbar').offsetHeight
}
}
}



// WEBPACK FOOTER //
// ./src/components/Tabbar.vue